<template>
    <div class="modal-base">
        <component
            class="modal-base__component"
            :is="currentComponent"
            @close-modal="closeModal"
        />
        <div class="modal-base__backdrop" />
    </div>
</template>

<script>
import { modalMixin } from '@/mixins/modal'

export default {
    mixins: [modalMixin],

    provide() {
        return {
            closeModal: this.closeModal
        }
    },

    computed: {
        modal() {
            return this.$store.getters.getModal
        }
    },
    data() {
        return {
            currentComponent: null // Placeholder for the dynamically loaded component
        }
    },
    methods: {
        async loadComponent() {
            try {
                const componentPath = this.modal.componentPath

                // Dynamically import the component based on the provided path
                const component = await import('@/components/' + componentPath + '.vue')

                // Assign the loaded component
                this.currentComponent = component.default || component
            } catch (error) {
                console.error('Failed to load component', error)
            }
        },

        closeModal() {
            const { canClose } = this.$children[0].$children[0]

            if (!canClose) {
                return
            }

            this.$el.classList.add('--closing')
            this.$el.classList.remove('--visible')

            setTimeout(() => {
                this.$store.dispatch('toggleModal', false)
            }, 400)
        },

        onEscapeKey(event) {
            if (event.key === 'Escape') {
                this.closeModal()
            }
        }
    },
    mounted() {
        // Load the component when the modal is mounted
        this.loadComponent()

        // Add the visible class after a short delay
        setTimeout(() => {
            this.$el.classList.add('--visible')
        }, 100)

        // Add listener for Escape key
        document.addEventListener('keydown', this.onEscapeKey)
    },
    beforeDestroy() {
        // Remove the Escape key listener
        document.removeEventListener('keydown', this.onEscapeKey)
    }
}
</script>

<style lang="scss">
.modal-base {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;

    &__backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: transparent;
        opacity: 0.5;
        transition: 0.2s ease-in-out;
    }

    &__component {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -40%);
        opacity: 0;
        transition: 0.2s ease-in-out;
        z-index: 10;
        transition-delay: .1s;
    }

    &.--closing {
        .modal-base__component {
            transition-delay: 0s;
        }
    }

    &.--visible {
        .modal-base {
            &__backdrop {
                background-color: var(--color-primary);
            }

            &__component {
                transform: translate(-50%, -50%);
                opacity: 1;
            }
        }
    }
}
</style>